module.exports = __webpack_public_path__ + "img/kdLogo_CH.a9f5ffd5.svg";